<div class="kt-portlet">
	<div class="kt-portlet__head kt-portlet__head__custom">
		<div class="kt-portlet__head-progress">
			<!-- here can place a progress bar-->
			<mat-progress-bar mode="indeterminate" *ngIf="viewLoading"></mat-progress-bar>
		</div>
		<div class="kt-portlet__head-label">
			<h3 class="kt-portlet__head-title">{{data.title}}</h3>
			<span class="kt-portlet__head-icon kt-hide">
				<i class="la la-gear"></i>
			</span>
		</div>
	</div>
	<div class="kt-form">
		<div class="kt-portlet__body">
			<div class="form-group kt-form__group row">
				<div class="col-lg-12">
					{{ viewLoading ? data.waitDesciption : data.description}}
				</div>
			</div>
		</div>
		<div class="kt-portlet__foot kt-portlet__no-border kt-portlet__foot--fit text-right">
			<div class="kt-form__actions kt-form__actions--sm">
				<div fxLayout="row" fxLayout.lt-md="column" fxFlex fxLayoutGap="0px">
					<div fxFlex align="right">
						<button class="green-text" mat-raised-button (click)="onYesClick()" cdkFocusInitial
							[disabled]="viewLoading">{{'Accept'}}</button>&nbsp;
						<button class="red-text" mat-raised-button (click)="onNoClick()">{{'Close'}}</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>